// extracted by mini-css-extract-plugin
export var bodyFont = "industry-module--body-font--c46f0";
export var button = "industry-module--button--71e52";
export var container = "industry-module--container--eb1ef";
export var contentContainer = "industry-module--contentContainer--a940e";
export var employee = "industry-module--employee--976cc";
export var explain = "industry-module--explain--928f9";
export var fill = "industry-module--fill--8eec5";
export var industryLogo = "industry-module--industryLogo--90e10";
export var industryPageLink = "industry-module--industryPageLink--77348";
export var journey = "industry-module--journey--b58c7";
export var journeyBottom = "industry-module--journeyBottom--79460";
export var journeyLine = "industry-module--journeyLine--9acae";
export var journeyPath = "industry-module--journeyPath--5a300";
export var mainContainer = "industry-module--mainContainer--5318d";
export var name = "industry-module--name--9fec6";
export var rolesContainer = "industry-module--rolesContainer--8ec4b";
export var userIcon = "industry-module--userIcon--65c5e";